jQuery(function($) {

    $(window).on('scroll', function(){
        var w = $(window);
        if (w.outerWidth() < 1024){
            var $filters = $('.uv-filters');
            var $topbar = $('.uv-topbar');
            var $topbarTitle = $('.uv-topbar-title');
            var topbarTop = $topbar.length ? $topbar.offset().top : null;

            if (w.scrollTop() >= topbarTop){
                $topbarTitle.addClass('sticky');
            }
            else {
                $topbarTitle.removeClass('sticky');
            }
        }
    });

    $(document).on("click", ".js-home-disc", function() {
        $(this).toggleClass("open");
    });
    $(document).on("click", "[data-modal-protected]", function(e) {
        e.stopPropagation();
    });
    $(document).on("click", "[data-modal-dismiss]", function(e) {
        e.preventDefault();
        var $me = $(this);
        var $modal = $me.closest("[role=dialog]");
        var id = $me.attr("id");
        var $btns = $("[data-modal-id=" + id + "]");
        var $vid = $me.find("video");
        var $if = $me.find("iframe[src*=youtube]");
        $modal.attr("aria-hidden", "true");
        $btns.attr("aria-expanded", "false");
        $("body").attr("data-modal-open", "false");
        if (typeof jwplayer !== "undefined" && jwplayer) {
            jwplayer().pause();
        }
        if ($vid.length) {
            $vid[0].pause();
        }
        if ($if.length) {
            var src = $if.attr("src");
            $if.attr("src", "");
            $if.attr("src", src.replace('?autoplay=1', ''));
        }
    });
    $(document).on("click", "[data-modal-id]", function(e) {
        var $me = $(this);
        var modalId = $me.data("modal-id");
        var $modal = $("#" + modalId);
        if ($modal.length) {
            var $if = $modal.find("iframe[src*=youtube]");

            e.preventDefault();
            if ($if.length) {
                var src = $if.attr("src");
                $if.attr("src", src.replace('?autoplay=1', '') + '?autoplay=1')
            }
            $me.attr("aria-expanded", "true")
            $modal.attr("aria-hidden", "false");
            $("body").attr("data-modal-open", "true");
        }
    });
    $(".s-disclaimers [aria-controls]").on('click', function(e) {
        e.preventDefault();
        var $me = $(this);
        var isOpen = $me.attr("aria-pressed").toLowerCase() == "false";
        var id = $me.attr("aria-controls");
        var el = document.getElementById(id);
        if (el) {
            var $el = $(el);
            $el.attr("aria-hidden", (!isOpen).toString().toLowerCase());
            $me.attr("aria-pressed", isOpen.toString().toLowerCase());
        }
    });

    $(".blog-archive-list [aria-controls]").on('click', function(e) {
        e.preventDefault();
        var $me = $(this);
        var isOpen = $me.attr("aria-pressed").toLowerCase() == "false";
        var id = $me.attr("aria-controls");
        var el = $(this).parents('li').find('.month-panel-item')[0];
        if (el) 
        {
            var $el = $(el);
            $el.attr("aria-hidden", (!isOpen).toString().toLowerCase());
            $me.attr("aria-pressed", isOpen.toString().toLowerCase());
        }
    });

    $(".tb-tooltip button[aria-controls]").on('click', function(e){
        e.preventDefault();
        var $me = $(this);
        var isOpen = $me.attr("aria-pressed").toLowerCase() == "true";
        var id = $me.attr("aria-controls");
        var $el = id ? $("#" + id) : null;
        if (!$el.length)  return;
        $el.attr("aria-hidden", isOpen.toString().toLowerCase());
        $me.attr("aria-pressed", (!isOpen).toString().toLowerCase());
        setTooltipPosition($el);
    });
    $(document).on("click", function(e){
        if ($(e.target).closest('.tb-tooltip').length) return;
        $(".tb-tooltip button[aria-pressed=true]").each(function(){
            $(this).trigger('click');
        });
    });

    $(".custom-cont table").each(function() {
        $(this).wrap("<div class='table-responsive'></div>");
    });
    $('.vehicle-images-slider #carousel').flexslider({
        animation: "slide",
        selector: ".js-carousel-slides > li",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 80,
        itemMargin: 5,
        asNavFor: '#slider'
    });
    $('.vehicle-images-slider #slider').flexslider({
        animation: "slide",
        selector: ".js-vehicle-slides > li",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        sync: "#carousel",
        after: function(slider) {
            var srcImg = $('.js-vehicle-slides .flex-active-slide img').attr('src');
            var imgname = srcImg.substr(srcImg.lastIndexOf('/') + 1);
            if (slider.currentSlide > 2 && (window.location.href.indexOf("aris") > -1)) {
                dataLayer.push({
                    'event': 'genericEvent',
                    'eventCategory': 'Site Actions',
                    'eventAction': 'Slider View',
                    'eventLabel': 'Slide ' + slider.currentSlide + '  ' + imgname
                });
            }
        }
    });
    if ($('#price-slider').length > 0 && $('#price-slider').length) {
        $('#year-slider').noUiSlider({
            start: [2012, 2014],
            connect: true,
            range: {
                'min': 2000,
                'max': 2014
            }
        });
        $('#price-slider').noUiSlider({
            start: [25000, 40000],
            connect: true,
            range: {
                'min': 0,
                'max': 50000
            }
        });
    }
    $(".filter-group .expand-filter").on("click", function(e) {
        $(this).parent().toggleClass("open");
        e.preventDefault();
    })
    $('.js-submit').on('click', function(e) {
        $(this).hide();
        $('#spinner').show();
        $('.control-group input,textarea').prop('readonly', true);
        $('.control-group').attr('style', 'opacity:0.5');
    });
    $('.tab-links a').on("click", function(e) {
        var currentAttrValue = $(this).attr('href');

        $(currentAttrValue).addClass("active").siblings().removeClass("active");
        $(this).parent('li').addClass('active').siblings().removeClass('active');

        e.preventDefault();

    });

    // Bind to Date and Time pickers
    $('.js-datepicker').pickadate();
    $('.js-timepicker').pickatime();
    // Display loaded slider images (prevents flashing)
    // Run before initiating sliders
    displaySlidesLoaded();
    if ($('.main-feature iframe').attr('src') != null) {
        if ($('.main-feature iframe').attr('src').indexOf('youtube.com') > -1) {
            $('.main-feature iframe[src*="youtube.com"]').wrap('<div class="embed-container"></div>');
        }
        if ($('.main-feature iframe').attr('src').indexOf('vimeo.com') > -1) {
            $('.main-feature iframe[src*="vimeo.com"]').wrap('<div class="embed-container"></div>');
        }
    }
    $('#siteMain .slider > div > a').on('click', function(e) {
        dataLayer.push({
            'event': 'genericEvent',
            'eventCategory': 'Internal Link Click',
            'eventAction': 'Homepage Banner Link',
            'eventLabel': $(this).attr('href')
        });
    });
    $('#cphBody_rptTiles_lnkTarget_1').on('click', function(e) {
        dataLayer.push({
            'event': 'genericEvent',
            'eventCategory': 'Internal Link Click',
            'eventAction': 'Sell Now Homepage CTA',
        });
    });
    $('a[href="#request-valuation"]').on('click', function(e) {
        dataLayer.push({
            'event': 'genericEvent',
            'eventCategory': 'Internal Link Click',
            'eventAction': 'Request Valuation Button',
        });
    });
    if ($(window).width() > 767) {
        $(".form-tabs").accTabs();
        window.tabsLoaded = true;
    } else {
        $('.form-tabs .form-tab:first-of-type').show();
        // number the service booking tabs for mobile
        var tabs = $('.service-tabs h3:visible');
        for (var i = 0; i < tabs.length; i++) {
            $(tabs[i]).find('.tab-number').html('0' + (i + 1));
        }
    }
    $('.sell-valuation #js-tabs_control-item--00').on('click', function(e) {
        changeTab(0);
    });
    $('.sell-valuation #js-tabs_control-item--01').on('click', function(e) {
        passTab1(1);
    });
    $('.sell-valuation #js-tabs_control-item--02').on('click', function(e) {
        passTab1(2);
    });
    $('.sell-valuation #tab-1-next').on('click', function(e) {
        e.preventDefault();
        passTab1(1);
    });
    $('.sell-valuation #tab-2-next').on('click', function(e) {
        e.preventDefault();
        changeTab(2);
    });
    $('.sell-valuation .form-tabs input').on('blur', function() 
    {
        if ($('#cphBody_sellinputmake').val() != "" && $('#cphBody_sellinputmodel').val() != "" && $('#cphBody_sellinputseries').val() != "" && $('#cphBody_sellinputyear').val() != "") 
        {
            $('#tab-1-next').prop('disabled', false);
            console.log(1);
            var phoneMand = false;
            if($(".js-sun-mand").length > 0 && $('#cphBody_sellinputphone').val() == "")
            {
                phoneMand = true;
            }
            if ($('#cphBody_sellinputfirstname').val() != "" && $('#cphBody_sellinputlastname').val() != "" && $('#cphBody_sellinputemail').val() != "" && !phoneMand) 
            {
                var prefPhone = $('#cphBody_prefPhone').length > 0 ? $('#cphBody_prefPhone').is(':checked') : $('input[name="CommunicationPreference_Field.Options"]:checked').val() == "2";
                console.log(2);
                if (prefPhone) 
                {
                    console.log(3);
                    if ($('#cphBody_sellinputphone').val() == "") {
                        console.log(4);
                        $('#cphBody_cmdSubmit').prop('disabled', true);
                    } else {
                        console.log(5);
                        $('#cphBody_cmdSubmit').prop('disabled', false);
                    }
                } 
                else 
                {
                    console.log(6);
                    $('#cphBody_cmdSubmit').prop('disabled', false);
                }
            } else {
                console.log(7);
                $('#cphBody_cmdSubmit').prop('disabled', true);
            }
        } else {
            console.log(8);
            $('#tab-1-next').prop('disabled', true);
            $('#cphBody_cmdSubmit').prop('disabled', true);
        }
    });
    $('#cphBody_prefPhone, #cphBody_prefEmail').on('change', function() {
        if ($('#cphBody_prefPhone').is(':checked')) {
            $('#cphBody_sellinputphone').siblings('label').html('Phone Number <span>*</span>');
        }
        if ($('#cphBody_prefEmail').is(':checked')) {
            $('#cphBody_sellinputphone').siblings('label').html('Phone Number');
        }
        if ($('#cphBody_sellinputphone').val() == "") {
            $('#cphBody_cmdSubmit').prop('disabled', true);
        }
    });
    // Refine Search Show/Hide filter
    /*
    var showHideFilterButton = $('.js-show-hide-filter');
    if( showHideFilterButton.length ) {
    	showHideFilterButton.click(function() {
    		$('.filter-container .filter-section').slideToggle();
    	});
    }
    */
    // Withhold loading of GMap iframes until after page load
    // iframe src is stored in data-src and swapped here
    $('.js-load-map-source').each(function() {
        $(this).attr('src', $(this).data('src'));
    });
    if (!$('#instamagram').length) {
        instagramReplace.init();
    }
    var autoplay = !$(".banner-slide:first iframe").length;
    $('.home-banner-slider').not('.slick-initialized').slick({
        dots: false,
        arrows: true,
        autoplay: autoplay,
        autoplaySpeed: 6000
    });
    // Current-Offers/NewVehicle slider
    // var newCarSlider = $("#new-car-slider");
    // if (newCarSlider.length) {
    // 	setupNewCarSlider(newCarSlider);
    // }
    $('.new-car-slider-new').not('.slick-initialized').slick({
        dots: true,
        arrows: false,
        autoplay: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('.slick.whats-hot').not('.slick-initialized').slick({
        dots: true,
        arrows: false,
        autoplay: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    // var ctaSlider = $("#cta-slider");
    // if (ctaSlider.length) {
    // 	setupCtaSlider(ctaSlider);
    // }
    createTeamBox();
    // ZOOM 
    $('.vehicle-photo').hover(function() {
        $(".vehicle-photo").addClass('transition');
    }, function() {
        $(".vehicle-photo").removeClass('transition');
    });
    if ($('.video-modal').length) {
        $(document).on('closing', '.remodal', function(e) {
            var target = $(this);
            var update = target.find('iframe');
            var src = update.attr('src');
            update.attr('src', src);
        });
    }
    $('.ui-contact-module-respond').click(function() {
        $(".ui-contact-module").toggleClass("open");
        $("html").toggleClass("disable-scrolling")
    });
    if ($(".special-map").length) {
        $('.special-map map').imageMapResize();
        setEqualSpecialLocationBoxTextHeight();
        setSpecialMapEventHandlers();
    }
    if ($(".mct-team-box").length) {
        setTeamEventHandlers();
    }
    // if (window.location.href.indexOf('/special-offers') > 0) {
        // $('.ac-current-offer-tag').hide();
    // }

    checkToyotaCertifiedUrl();
    var ll = new LazyLoad({
        class_loading: "lazy",
        class_loaded: "loaded",
        class_error: "error",
    });

    specialcars.init();

    if (localStorage.getItem("btn") !=='saved' ){
        var customHomeModal = $('#custom-home-modal');
        if($(customHomeModal).length){
            var inst = $(customHomeModal).remodal();
            inst.open();
        }
    }
    // add local storge when 'close & remember button' clicked.
    $('#btnDoNotShow').click(function (e) {
        if (e.target){
            localStorage.setItem('btn', 'saved');
        }
    });
});

function setTooltipPosition($el) {
    $el.attr('css', "");

    const right = $(window).width() - ($el.offset().left + $el.outerWidth());
    
    if (right < 16){
        $el.css('left', (right - 16)  + "px");
    }
}


function changeTab(num) {
    $('.js-tabs_control li').removeClass('js-tabs_control-item--active');
    $('.js-tabs_control button').attr('aria-selected', 'false');
    $('.js-tabs .form-tab').attr('aria-hidden', 'false').removeClass('js-tabs_panel--active').hide();
    $('.js-tabs_control li').eq(num).addClass('js-tabs_control-item--active');
    $('.js-tabs_control li').eq(num).find('button').attr('aria-selected', 'true');
    $('.js-tabs .form-tab').eq(num).attr('aria-hidden', 'true').addClass('js-tabs_panel--active').show();
    $('.form-tabs > h3').removeClass('active');
    $('.form-tabs > h3').eq(num).addClass('active');
    $('.form-tab').removeClass('active');
    $('.form-tab').eq(num).addClass('active');
    var i = 0;
    while (i < num) {
        $('.form-tabs > h3').eq(i).addClass('complete');
        i++;
    }
    if (!window.tabsLoaded) {
        $('html,body').animate({ scrollTop: $($('.form-tabs > h3').eq(num)).offset().top }, 500);
    }
    if (num != 0) {
        if (document.location.hostname !== 'localhost') {
            dataLayer.push({
                'event': 'genericEvent',
                'eventCategory': 'Site Actions',
                'eventAction': 'Request a Valuation Tab Change',
                'eventLabel': 'Tab ' + (num + 1) + ' Reached'
            });
        }
    }
}

function passTab1(goto) {
    $('.js-errors-tab1').hide();
    var errors = false;
    if ($('#cphBody_sellinputmake').val() == "") {
        $('#cphBody_sellinputmake').addClass('error');
        errors = true;
    }
    if ($('#cphBody_sellinputmodel').val() == "") {
        $('#cphBody_sellinputmodel').addClass('error');
        errors = true;
    }
    if ($('#cphBody_sellinputseries').val() == "") {
        $('#cphBody_sellinputseries').addClass('error');
        errors = true;
    }
    if ($('#cphBody_sellinputyear').val() == "") {
        $('#cphBody_sellinputyear').addClass('error');
        errors = true;
    }
    if (errors) {
        $('.js-errors-tab1').show();
        changeTab(0);
        if ($('#form-tab-1').length) {
            $('html,body').animate({ scrollTop: $('#form-tab-1').offset().top }, 500);
        }
        $('#tab-1-next').prop('disabled', true);
        return false;
    } else {
        $('#cphBody_sellinputmake, #cphBody_sellinputmodel, #cphBody_sellinputyear, #cphBody_sellinputseries').removeClass('error');
        changeTab(goto);
        $('#tab-1-next').prop('disabled', false);
        return true;
    }
}

var instagramReplace = {
    sites: {
        "chatswoodtoyota.com.au": {
            instagramImg: '/img/instagram/chatswoodtoyota.png',
            instagramUrl: 'https://www.instagram.com/chatswoodtoyota/'
        },
        "www.cmitoyota.com.au": {
            instagramImg: '/img/instagram/cmitoyota.png',
            instagramUrl: 'https://www.instagram.com/cmitoyota/'
        },
        "toowoombatoyota.com.au": {
            instagramImg: '/img/instagram/toowoombatoyota.png',
            instagramUrl: 'https://www.instagram.com/toowoombatoyota/'
        },
        "sunshinetoyota.com.au": {
            instagramImg: '/img/instagram/sunshinetoyotaau.png',
            instagramUrl: 'https://www.instagram.com/sunshinetoyotaau/'
        },
        "camberwelltoyota.com.au": {
            instagramImg: '/img/instagram/camberwelltoyota.png',
            instagramUrl: 'https://www.instagram.com/camberwelltoyota/'
        }
    },
    init: function() {
        $.each(instagramReplace.sites, function(location, site) {
            if (location == window.location.hostname) {
                $('#instagram').append('<a href="' + site.instagramUrl + '" target="_blank" id="instagram-image" style="width: 100%;"><img src="' + site.instagramImg + '" style="max-width:100%;"/></a>');
            }
        });
    }
}

function displaySlidesLoaded() {
    $('.slider li').each(function() {
        $(this).addClass('loaded--display');
    });
}

// function setupNewCarSlider(newCarSlider) {
// 	enquire.register("screen and (max-width: 740px)", {
// 		match: function () {
// 			newCarSlider.flexslider({
// 				animation: "slide",
// 				selector: "ul > li",
// 				animationSpeed: 500,
// 				directionNav: true,
// 				controlNav: false,
// 				animationLoop: true,
// 				slideshow: false,
// 				useCSS: false
// 			});
// 		},
// 		unmatch: function () {
// 			newCarSlider.flexslider('destroy');
// 		}
// 	});
// }
// function setupCtaSlider(ctaSlider) {
// 	enquire.register("screen and (max-width: 740px)", {
// 		match: function () {
// 			ctaSlider.flexslider({
// 				animation: "slide",
// 				selector: "ul > li",
// 				animationSpeed: 500,
// 				directionNav: true,
// 				controlNav: false,
// 				animationLoop: true,
// 				slideshow: false,
// 				useCSS: false,
// 				touch: true
// 			});
// 		},
// 		unmatch: function () {
// 			ctaSlider.flexslider('destroy');
// 		}
// 	});
// }

function createTabs() {
    var $tabs = $('.tabs'),
        $toggle = $('.accordion-toggle');
    $toggle.removeClass('open');
    $tabs.each(function(index) {
        var $this = $(this),
            $links = $this.find('> li a'),
            $panes = $this.nextAll('.panes:first').find('> .pane'),
            tabID = 'tabid-' + window.location.pathname + '-' + index,
            tabHasCookie = $this.data('cookie'),
            tabCookie = tabHasCookie ? cookie.read(tabID) : 0;

        if (tabHasCookie) {
            $links.eq(tabCookie).addClass('tab--is_current');
            $panes.hide().attr('aria-hidden', true);
            $panes.eq(tabCookie).show().attr('aria-hidden', false);
        } else {
            $links.eq(0).addClass('tab--is_current');
            $panes.not(':first').attr('aria-hidden', true);
        }
        $links.on('click', function(e) {
            e.preventDefault();
            var $this = $(this),
                idx = $this.parent().index();
            if (!$this.hasClass('tab--is_current')) {
                $links.removeClass('tab--is_current');
                $this.addClass('tab--is_current');
            }
            $panes.hide().attr('aria-hidden', true);
            $panes.eq(idx).show().attr('aria-hidden', false);
            if (tabHasCookie)
                cookie.set(tabID, idx);
        });
    });
}

function createAccordions() {
    var $toggle = $('.accordion-toggle'),
        $pane = $('.pane');
    $pane.removeAttr('style');
    $toggle.first().addClass('open');
    $toggle.on('click', function(e) {
        e.preventDefault();
        var $this = $(this);

        $this.toggleClass('open');
    });
}

function createTeamBox() {
    var query1 = "(max-width: 992px)",
        query2 = "(min-width: 992px)",
        handler1 = {
            match: function() {
                createAccordions();
            },
            unmatch: function() {
                createTabs();
            }

        },
        handler2 = {
            match: function() {
                createTabs();
            },
            unmatch: function() {
                createAccordions();
            }
        }
    enquire.register(query1, handler1);
    enquire.register(query2, handler2);
}

function closeModal() {
    if (!$.remodal) return;
    var inst = $.remodal.lookup[$('[data-remodal-id=msg]').data('remodal')];
    if (inst) inst.close();
    inst = $.remodal.lookup[$('[data-remodal-id=modal]').data('remodal')];
    if (inst) inst.close();
}

function setSpecialMapEventHandlers() {
    var resizeTimer;
    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleResize, 250);
    });
    $('.special-map area').each(function() {
        var $me = $(this);
        $me.data("isHovered", false);
        $me.data("isInfoboxHovered", false);
        $me.hover(function() {
            $('.special-map area').not($me).trigger("mouseleave");
            $me.data("isHovered", true);
            setTimeout(function() {
                setSpecialMapVisibility($me);
            }, 1);
        }, function() {
            $me.data("isHovered", false);
            setTimeout(function() {
                setSpecialMapVisibility($me);
            }, 500);
        });
        $me.on("click", function(e) {
            e.preventDefault();
            var $me = $(this);
            var id = $me.attr("href");
            var $box = $(id + "-infobox");
            $box.trigger('click');
        });
    });
    $('.special-map-infobox').each(function() {
        var $me = $(this);
        var href = "#" + $me.attr("id").replace("-infobox", "");
        var $area = $("area[href=" + href + "]");
        $me.hover(function() {
            $area.data("isInfoboxHovered", true);
        }, function() {
            $area.data("isInfoboxHovered", false);
        });
    });
    $('.special-map-infobox').on("click", function(e) {
        e.preventDefault();
        var $me = $(this);
        var id = $me.attr("href");
        var $box = $(id);
        $box.find('button').trigger('click');
        scrollToElement($box);
    });
    $(".special-location-box button").on("click", function(e) {
        e.preventDefault();
        var $box = $(this).closest(".special-location-box");
        $box.toggleClass("active");
        if ($box.hasClass("active")) {
            var $activeBoxes = $(".special-location-box.active").not($box);
            $activeBoxes.removeClass("active");
            setSpecialLocationMarginBottom($box);
        } else {
            var $ul = $(".special-location-boxes");
            $ul.css("margin-bottom", "0");
        }
    });
}

function setTeamEventHandlers() {
    $(".mct-team-box button").on("click", function(e) {
        var $me = $(this);
        var index = $me.parent().index();
        var $panesLinks = $(".panes .accordion-toggle");

        if ($panesLinks.first().is(":visible")) {
            var $pLink = $panesLinks.filter(":nth-of-type(" + (index + 1) + ")");
            $pLink.trigger("click")
            scrollToElement($pLink);
        } else {
            var $tabs = $(".tabs");
            var $li = $tabs.children("li:nth-child(" + (index + 1) + ")");
            $li.children("a").trigger("click");
            scrollToElement($li);
        }
    });
}

function handleResize() {
    setTimeout(function() {
        resetSpecialLocationMarginBottom();
        setEqualSpecialLocationBoxTextHeight()
    }, 600);
}

function setEqualSpecialLocationBoxTextHeight() {
    setEqualHeight($(".special-location-box-text"));
}

function setEqualHeight($el) {
    var max = 0;
    $el.each(function() {
        max = Math.max(max, $(this).outerHeight());
    });
    $el.css("min-height", max + "px");
}

function resetSpecialLocationMarginBottom() {
    var $box = $(".special-location-box.active");
    if ($box.length) {
        setSpecialLocationMarginBottom($box);
    }
}

function setSpecialLocationMarginBottom($box) {
    var $ul = $(".special-location-boxes");
    var $img = $box.find('.special-location-box-image');
    var $departments = $box.find(".special-location-box-departments");
    var boxTop = $box.position().top;
    var boxHeight = $box.outerHeight();
    var departmentHeight = $departments.outerHeight();
    var imageHeight = $img.outerHeight();
    var imageHeightDifferenceAfterResize = imageHeight * 0.23;
    var boxBottom = boxTop + boxHeight + departmentHeight;
    var ulHeight = $ul.outerHeight();
    var difference = boxBottom + imageHeightDifferenceAfterResize - ulHeight;
    $ul.css("margin-bottom", difference > 0 ? difference + "px" : "0");
}

function scrollToElement($el) {
    $('html,body').animate({
        scrollTop: $el.offset().top
    }, 500);
}

function setSpecialMapVisibility($a) {
    var infoboxId = $a.attr("href") + "-infobox";
    var $i = $(infoboxId);
    if ($a.data("isHovered") || $a.data("isInfoboxHovered")) {
        $i.addClass("active");
    } else {
        $i.removeClass("active");
    }
}

function checkToyotaCertifiedUrl() {
    var href = window.location.href;
    if (href.indexOf('/inventory/pre-owned?makes=toyota&certified=yes') > -1) {
        var shown = sessionStorage.getItem('isshow');
        if (shown != "t") {
            $(".uv-tile-toyotacertified button").trigger('click');
            sessionStorage.setItem('isshow', "t");
        }
    }
}

// special offers page 
var specialcars = {
    init: function() {
        this.bindEvents();
        if ($(window).width() > 767){
            $('.detail-filter-container .icon-open').trigger('click');
        }
        setTimeout(function(){
            $('.detail-filter-container .uninit').removeClass('uninit');
        }, 350);
        this.updateResults();
    },
    getParameterByName: function(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    amendUrl: function(){
        var $checked = $(".detail-filter-container .filter-radio input:checked");
        var listString = "";
        $checked.each(function () {
            listString += this.attributes["data-model"].value + ",";
        });
        var vcid = this.getParameterByName('vc', location.href);
        vcid = vcid ? window.encodeURIComponent(vcid) : '';
        listString = listString.slice(0, -1);
        var vcidString = vcid ? ('?vc=' + vcid + '&') : '?';
        var newurl = window.location.href.split("?")[0] + vcidString + 'models=' + listString;
        window.history.pushState({ path: newurl }, '', newurl);

        var top = $('.ac-special-vehicle-listings').offset().top;
        $('html, body').animate({
            scrollTop: top - 70
        }, 200);
    },
    setInputsFromUrl: function(){
        var $inputs = $(".detail-filter-container .filter-radio input");
        var qs = location.search.split('models=');
        $inputs.each(function(){
            this.checked = false;
        });
        if (qs.length > 1){
            var qsArray = qs[1].split(',');
            for (var i = 0; i != qsArray.length; ++i){
                var v = qsArray[i];
                var $i = $inputs.filter('[data-model=' + v + ']');
                if ($i.length){
                    $i[0].checked = true;
                }
            }
        }
    },
    bindEvents: function(){
        var that = this;

        $('.detail-filter-container .so-nav li > a').on('click', function(e){
            var $me = $(this);
            var href = $me.attr('href');
            if (0 == href.indexOf('#') && href.length > 1){
                e.preventDefault();
                var $el = $(href);
                var $nav = $('.detail-filter-container .so-nav');
                var h = $nav.length ? $nav.outerHeight() : 0;
                $('html,body').animate({ scrollTop: $el.offset().top - h - 20 }, 500);
            }
        });
        window.addEventListener('popstate', function(e){
            that.setInputsFromUrl();
            that.updateResults();
        });
        $(".detail-filter-container .filter-radio input").on('change', function(){
            that.amendUrl();
            that.updateResults();
        });
        $(".detail-filter-container .js-clear-filters").on('click', function() {
            var $check = $(".detail-filter-container .filter-radio input");
            var url = location.origin + location.pathname;
            $check.each(function(){
                this.checked = false;
            });
            that.amendUrl();
            that.updateResults();
        });
        $('.detail-filter-container .toggle-filter').on('click', function(e){
            $(this).addClass("open");
        });
        $(".detail-filter-container .icon-open").on('click', function(e) {
            e.preventDefault();
            $(this).closest(".toggle-filter").addClass("open");
        });
        $(".detail-filter-container .icon-close").on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).closest(".toggle-filter").removeClass("open");
        });
        $(".detail-filter-container .mobile-btn").on('click', function(e) {
            e.preventDefault();
            $(".detail-filter-container .icon-open").trigger('click');
        });
        $(".detail-filter-container .vc-collapse").each(function() {
            var $me = $(this);
            $me.find(".panel-btn").on('click', function(e) {
                e.preventDefault();
                $(this).toggleClass('active');
                $me.closest('.vc-collapse').find('.accordion-panel').toggleClass('open');
            });
        });
    }, 
    updateResults: function() {
        var $clear = $('.detail-filter-container .clear');
        var $checked = $(".detail-filter-container .filter-radio input:checked");
        var $listings = $('.detail-filter-container .ac-special-vehicle-listings');
        if ($checked.length == 0){
            $clear.addClass('hidden');
            $('.ac-special-vehicle').removeClass('hidden');
        } 
        else {
            var listString = "";
            $clear.removeClass('hidden');
            $checked.each(function () {
                listString += "." + this.attributes["data-model"].value + ",";
            });
            listString = listString.slice(0, -1);
            $('.ac-special-vehicle').not(listString).addClass('hidden');
            $('.ac-special-vehicle').filter(listString).removeClass('hidden');
        }
    }
}
